// extracted by mini-css-extract-plugin
export var link = "WmTvD6BR";
export var arrow = "IGSA62fj";